export const calculateBMI = (height: number, weight: number) => {
  const bmiValue = weight / (height / 100) ** 2
  return Math.round(bmiValue * 100) / 100
}
